import React, { useState, useEffect, useRef } from 'react';
import s from './TeacherThemes.module.css';
import ts from './TeacherTests.module.css';

const EMPTY_FORM = {
  mavzu: '',
  test_savol_uz: '', V1_uz: '', V2_uz: '', V3_uz: '', V4_uz: '',
  test_savol_ru: '', V1_ru: '', V2_ru: '', V3_ru: '', V4_ru: '',
  test_savol_en: '', V1_en: '', V2_en: '', V3_en: '', V4_en: '',
};

// Парсинг .txt файла
function parseTxtTests(text, mavzuId) {
  const blocks = text.trim().split(/\n{2,}/);
  const result = [];

  for (const block of blocks) {
    const lines = block.trim().split('\n').map(l => l.trim()).filter(Boolean);
    if (lines.length < 6) continue;

    const question = lines[0];
    const options = {};
    let answer = '';

    for (const line of lines.slice(1)) {
      const varMatch = line.match(/^([A-D])\.\s*(.*)/);
      if (varMatch) options[varMatch[1]] = varMatch[2];
      const ansMatch = line.match(/^ANSWER:\s*([A-D])/);
      if (ansMatch) answer = ansMatch[1];
    }

    if (!answer || !options[answer]) continue;

    // Правильный ответ — V1, остальные перемешиваем в V2, V3, V4
    const wrong = Object.entries(options)
      .filter(([k]) => k !== answer)
      .map(([, v]) => v);

    result.push({
      mavzu: Number(mavzuId),
      test_savol_uz: question, V1_uz: options[answer], V2_uz: wrong[0] || '', V3_uz: wrong[1] || '', V4_uz: wrong[2] || '',
      test_savol_ru: question, V1_ru: options[answer], V2_ru: wrong[0] || '', V3_ru: wrong[1] || '', V4_ru: wrong[2] || '',
      test_savol_en: question, V1_en: options[answer], V2_en: wrong[0] || '', V3_en: wrong[1] || '', V4_en: wrong[2] || '',
    });
  }
  return result;
}

export const TeacherTests = () => {
  const token = localStorage.getItem('token');

  const [tests, setTests] = useState([]);
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('list');
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState('uz');
  const [filterMavzu, setFilterMavzu] = useState('');

  // Импорт txt
  const [importing, setImporting] = useState(false);
  const [importMavzu, setImportMavzu] = useState('');
  const [importResults, setImportResults] = useState(null);
  const fileRef = useRef();

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [tRes, mRes] = await Promise.all([
        fetch('https://api.aiassessment.uz/api/kurs-mavzu-test/', {
          headers: { Authorization: `Token ${token}` },
        }),
        fetch('https://api.aiassessment.uz/api/kurs-mavzulari/?kurs=2', {
          headers: { Authorization: `Token ${token}` },
        }),
      ]);
      const tData = await tRes.json();
      const mData = await mRes.json();
      setTests(Array.isArray(tData) ? tData : []);
      setThemes(Array.isArray(mData) ? mData.sort((a, b) => a.tartib - b.tartib) : []);
    } catch {
      setError("Ma'lumotlarni yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  const openCreate = () => {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setError('');
    setSuccess('');
    setActiveTab('uz');
    setView('form');
  };

  const openEdit = (t) => {
    setForm({
      mavzu: t.mavzu ?? '',
      test_savol_uz: t.test_savol_uz ?? '', V1_uz: t.V1_uz ?? '', V2_uz: t.V2_uz ?? '', V3_uz: t.V3_uz ?? '', V4_uz: t.V4_uz ?? '',
      test_savol_ru: t.test_savol_ru ?? '', V1_ru: t.V1_ru ?? '', V2_ru: t.V2_ru ?? '', V3_ru: t.V3_ru ?? '', V4_ru: t.V4_ru ?? '',
      test_savol_en: t.test_savol_en ?? '', V1_en: t.V1_en ?? '', V2_en: t.V2_en ?? '', V3_en: t.V3_en ?? '', V4_en: t.V4_en ?? '',
    });
    setEditingId(t.id);
    setError('');
    setSuccess('');
    setActiveTab('uz');
    setView('form');
  };

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const buildBody = (f) => ({
    mavzu: Number(f.mavzu),
    test_savol_uz: f.test_savol_uz, V1_uz: f.V1_uz, V2_uz: f.V2_uz, V3_uz: f.V3_uz, V4_uz: f.V4_uz,
    test_savol_ru: f.test_savol_ru, V1_ru: f.V1_ru, V2_ru: f.V2_ru, V3_ru: f.V3_ru, V4_ru: f.V4_ru,
    test_savol_en: f.test_savol_en, V1_en: f.V1_en, V2_en: f.V2_en, V3_en: f.V3_en, V4_en: f.V4_en,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const url = editingId
        ? `https://api.aiassessment.uz/api/kurs-mavzu-test/${editingId}/`
        : 'https://api.aiassessment.uz/api/kurs-mavzu-test/';
      const res = await fetch(url, {
        method: editingId ? 'PATCH' : 'POST',
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(buildBody(form)),
      });
      if (!res.ok) {
        setError(JSON.stringify(await res.json()));
      } else {
        setSuccess(editingId ? 'Test yangilandi!' : 'Test qo\'shildi!');
        await fetchAll();
        setTimeout(() => setView('list'), 1200);
      }
    } catch {
      setError('Server bilan bog\'lanishda xatolik');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    await fetch(`https://api.aiassessment.uz/api/kurs-mavzu-test/${deleteId}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    setDeleteId(null);
    await fetchAll();
  };

  // Импорт из txt
  const handleFileImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const parsed = parseTxtTests(ev.target.result, importMavzu);
      setImportResults(parsed);
    };
    reader.readAsText(file, 'UTF-8');
    e.target.value = '';
  };

  const handleImportSave = async () => {
    if (!importResults?.length) return;
    setImporting(true);
    let ok = 0, fail = 0;
    for (const item of importResults) {
      const res = await fetch('https://api.aiassessment.uz/api/kurs-mavzu-test/', {
        method: 'POST',
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(item),
      });
      if (res.ok) ok++; else fail++;
    }
    setImporting(false);
    setImportResults(null);
    setImportMavzu('');
    await fetchAll();
    setSuccess(`${ok} ta test saqlandi${fail ? `, ${fail} ta xatolik` : '!'}`);
  };

  const getThemeName = (mavzuId) =>
    themes.find(m => m.id === mavzuId)?.nomi_uz ?? `#${mavzuId}`;

  const filtered = filterMavzu
    ? tests.filter(t => String(t.mavzu) === filterMavzu)
    : tests;

  const tabs = [
    { key: 'uz', label: 'UZ' },
    { key: 'ru', label: 'RU' },
    { key: 'en', label: 'EN' },
  ];

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Testlar boshqaruvi</h1>
        {view === 'list' ? (
          <button className={s.btnPrimary} onClick={openCreate}>+ Yangi test</button>
        ) : (
          <button className={s.btnSecondary} onClick={() => setView('list')}>← Ro'yxatga qaytish</button>
        )}
      </div>

      {view === 'list' && (
        <>
          {/* Фильтр + импорт */}
          <div className={ts.toolbar}>
            <div className={ts.filterRow}>
              <label className={ts.filterLabel}>Mavzu:</label>
              <select className={ts.filterSelect} value={filterMavzu} onChange={e => setFilterMavzu(e.target.value)}>
                <option value="">Barcha mavzular</option>
                {themes.map(m => (
                  <option key={m.id} value={m.id}>{m.tartib}. {m.nomi_uz}</option>
                ))}
              </select>
              <span className={ts.countBadge}>{filtered.length} ta test</span>
            </div>

            {/* Импорт из txt */}
            <div className={ts.importBox}>
              <select
                className={ts.filterSelect}
                value={importMavzu}
                onChange={e => setImportMavzu(e.target.value)}
              >
                <option value="">Mavzu tanlang (import uchun)</option>
                {themes.map(m => (
                  <option key={m.id} value={m.id}>{m.tartib}. {m.nomi_uz}</option>
                ))}
              </select>
              <label className={`${s.btnSecondary} ${ts.fileLabel} ${!importMavzu ? ts.fileLabelDisabled : ''}`}>
                📄 .txt fayldan import
                <input
                  ref={fileRef}
                  type="file"
                  accept=".txt"
                  style={{ display: 'none' }}
                  disabled={!importMavzu}
                  onChange={handleFileImport}
                />
              </label>
            </div>
          </div>

          {/* Предпросмотр импорта */}
          {importResults && (
            <div className={ts.importPreview}>
              <div className={ts.importPreviewHeader}>
                <span>📋 {importResults.length} ta test topildi — tekshirib ko'ring:</span>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button className={s.btnPrimary} onClick={handleImportSave} disabled={importing}>
                    {importing ? 'Saqlanmoqda...' : 'Saqlash'}
                  </button>
                  <button className={s.btnSecondary} onClick={() => setImportResults(null)}>Bekor</button>
                </div>
              </div>
              <div className={ts.importList}>
                {importResults.map((item, i) => (
                  <div key={i} className={ts.importItem}>
                    <div className={ts.importQ}><strong>{i + 1}.</strong> {item.test_savol_uz}</div>
                    <div className={ts.importAnswers}>
                      <span className={ts.correct}>✓ {item.V1_uz}</span>
                      {item.V2_uz && <span>{item.V2_uz}</span>}
                      {item.V3_uz && <span>{item.V3_uz}</span>}
                      {item.V4_uz && <span>{item.V4_uz}</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {success && <p className={s.successMsg} style={{ marginBottom: 12 }}>{success}</p>}

          {loading ? (
            <p className={s.loading}>Yuklanmoqda...</p>
          ) : (
            <div className={s.tableWrapper}>
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Mavzu</th>
                    <th>Savol (UZ)</th>
                    <th>To'g'ri javob</th>
                    <th>Amallar</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>Testlar yo'q</td></tr>
                  )}
                  {filtered.map((t, idx) => (
                    <tr key={t.id}>
                      <td>{idx + 1}</td>
                      <td><span className={s.badge}>{getThemeName(t.mavzu)}</span></td>
                      <td className={s.tdTitle}>{t.test_savol_uz?.slice(0, 70)}{t.test_savol_uz?.length > 70 ? '…' : ''}</td>
                      <td className={ts.tdCorrect}>{t.V1_uz}</td>
                      <td className={s.tdActions}>
                        <button className={s.btnEdit} onClick={() => openEdit(t)}>✏️</button>
                        <button className={s.btnDelete} onClick={() => setDeleteId(t.id)}>🗑</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {view === 'form' && (
        <form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.formTitle}>{editingId ? 'Testni tahrirlash' : 'Yangi test qo\'shish'}</h2>

          <div className={s.field} style={{ maxWidth: 400 }}>
            <label>Mavzu *</label>
            <select name="mavzu" value={form.mavzu} onChange={handleChange} required className={s.input}>
              <option value="">Mavzu tanlang</option>
              {themes.map(m => (
                <option key={m.id} value={m.id}>{m.tartib}. {m.nomi_uz}</option>
              ))}
            </select>
          </div>

          <div className={s.langTabs}>
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                className={`${s.langTab} ${activeTab === tab.key ? s.langTabActive : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {tabs.map(tab => (
            <div key={tab.key} className={activeTab === tab.key ? s.tabContent : s.tabHidden}>
              <div className={s.field}>
                <label>Savol ({tab.label}) *</label>
                <textarea
                  name={`test_savol_${tab.key}`}
                  value={form[`test_savol_${tab.key}`]}
                  onChange={handleChange}
                  className={s.textarea}
                  rows={3}
                  placeholder="Savol matnini kiriting..."
                />
              </div>
              <div className={ts.answersGrid}>
                {['V1', 'V2', 'V3', 'V4'].map((v, i) => (
                  <div key={v} className={`${s.field} ${i === 0 ? ts.correctField : ''}`}>
                    <label className={i === 0 ? ts.correctLabel : ''}>
                      {i === 0 ? '✓ To\'g\'ri javob (A)' : `Variant ${String.fromCharCode(66 + i - 1)}`}
                    </label>
                    <input
                      name={`${v}_${tab.key}`}
                      value={form[`${v}_${tab.key}`]}
                      onChange={handleChange}
                      className={`${s.input} ${i === 0 ? ts.correctInput : ''}`}
                      placeholder={i === 0 ? 'To\'g\'ri javob...' : `Variant ${String.fromCharCode(66 + i - 1)}...`}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}

          {error && <p className={s.error}>{error}</p>}
          {success && <p className={s.successMsg}>{success}</p>}

          <div className={s.formActions}>
            <button type="submit" className={s.btnPrimary} disabled={saving}>
              {saving ? 'Saqlanmoqda...' : (editingId ? 'Yangilash' : 'Saqlash')}
            </button>
            <button type="button" className={s.btnSecondary} onClick={() => setView('list')}>
              Bekor qilish
            </button>
          </div>
        </form>
      )}

      {deleteId && (
        <div className={s.modalOverlay}>
          <div className={s.modal}>
            <h3>Testni o'chirish</h3>
            <p>Haqiqatan ham bu testni o'chirmoqchimisiz?</p>
            <div className={s.modalActions}>
              <button className={s.btnDelete} onClick={handleDelete}>O'chirish</button>
              <button className={s.btnSecondary} onClick={() => setDeleteId(null)}>Bekor qilish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
